exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);z-index:9999}.modal,.modal-overlay{display:flex;justify-content:center;align-items:center}.modal{position:relative;background-color:snow;border-radius:5px;padding:0;box-shadow:0 0 10px rgba(0,0,0,.5);height:92%;width:92%;flex-direction:column}.modal-header{display:flex;align-items:center;justify-content:space-between;padding:6px;padding-left:20px;background-color:#252829;border-top-left-radius:5px;border-top-right-radius:5px}.topdiv{width:100%;height:100%}.token{color:#fff}.hidden{display:none}", ""]);

// exports
